import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import AuthorizedAction from './AuthorizedAction.js';
import { PlusButtonIcon } from './icons/PlusButtonIcon.jsx';
import styles from './Empty.module.css';

function Empty({
  children,
  content,
  action,
  actionComponent,
  actionAuthorization,
  addBtn,
  actionLoading = null,
  simplified,
  className = '',
}) {
  const renderActionButton = () => {
    if (actionComponent) return actionComponent;
    if (!action) return null;

    const renderButton = (
      singleAction,
      singleActionAuthorization,
      actionLabel
    ) => {
      const button = (
        <Button
          className="m-r-16"
          onClick={singleAction}
          bsStyle="success"
          disabled={actionLoading}
          addBtn
        >
          {addBtn ? <PlusButtonIcon /> : null}
          {actionLabel}
        </Button>
      );

      if (!singleActionAuthorization) return button;

      return (
        <AuthorizedAction
          action={singleActionAuthorization.action}
          subject={singleActionAuthorization.subject}
        >
          {button}
        </AuthorizedAction>
      );
    };

    if (!Array.isArray(action)) {
      return renderButton(
        action,
        actionAuthorization,
        content ? content.actionLabel : null
      );
    }

    return action.map((singleAction, index) => (
      <React.Fragment key={index}>
        {renderButton(
          singleAction,
          Array.isArray(actionAuthorization)
            ? actionAuthorization[index]
            : actionAuthorization,
          Array.isArray(content.actionLabel)
            ? content.actionLabel[index]
            : content.actionLabel
        )}
      </React.Fragment>
    ));
  };

  return content ? (
    <div
      className={`${styles.empty} flex ${className}`}
      style={{ backgroundColor: '#fff' }}
    >
      <div className={`${styles.component} component-hide-border`}>
        <Row style={{ display: 'flex', alignItems: 'center' }}>
          {simplified ? (
            <Col sm={12}>
              <div className="empty-titles m-b-24">
                <h1 className="h1 m-b-16">{content.title}</h1>
                {content.subtitle && <h3 className="h3">{content.subtitle}</h3>}
                <h5 className="h5 text-muted m-b-24">{content.description}</h5>
                {renderActionButton()}
              </div>
            </Col>
          ) : (
            <React.Fragment>
              <Col sm={6}>
                <div className={`img ${styles.emptyImg}`}>{content.image}</div>
              </Col>
              <Col sm={6}>
                <div className="text-left empty-info">
                  <div className="empty-titles m-b-24">
                    <h1 className="h1 m-b-16">{content.title}</h1>
                    <h5 className="h5">{content.subtitle}</h5>
                  </div>
                  <div className={`${styles.emptyDesc} text-muted m-b-24`}>
                    <p>{content.paragraphFirst}</p>
                    <p>{content.paragraphSecond}</p>
                    <p>{content.paragraphThird}</p>
                  </div>
                  {renderActionButton()}
                  {children}
                </div>
              </Col>
            </React.Fragment>
          )}
        </Row>
      </div>
    </div>
  ) : null;
}

export default Empty;
